import { type Result, err, ok } from 'neverthrow';
import { match } from 'ts-pattern';
import { z, type ZodType } from 'zod';

import { ParserError } from './error';
import type { ZodDescriptor } from './types/special';

export const deserializeZod = (
  descriptor: ZodDescriptor,
): Result<ZodType, ParserError> => {
  const res = match(descriptor)
    .with({ zod: 'string' }, () => z.string())
    .with({ zod: 'number' }, () => z.number())
    .with({ zod: 'boolean' }, () => z.boolean())
    .with({ zod: 'any' }, () => z.any())
    .with({ zod: 'enum' }, ({ values }) => {
      if (values.length === 0) {
        return null;
      }

      return z.enum(values as [string, ...string[]]);
    })
    .with({ zod: 'literal' }, ({ value }) => z.literal(value))
    .with({ zod: 'array' }, ({ items }) => {
      const itemSchema = deserializeZod(items);
      if (itemSchema.isErr()) {
        return null;
      }

      return z.array(itemSchema.value);
    })
    .otherwise(() => null);

  if (!res) {
    return err(ParserError.ZodDeserializationError);
  }

  return ok(res);
};
